import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { EventDispatcher } from '../core/EventDispatcher.js';
import { Texture } from '../textures/Texture.js';
import { LinearFilter } from '../constants.js';
import { Vector4 } from '../math/Vector4.js';
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/

var WebGLRenderTarget = /*#__PURE__*/function (_EventDispatcher) {
  _inherits(WebGLRenderTarget, _EventDispatcher);

  var _super = _createSuper(WebGLRenderTarget);

  function WebGLRenderTarget(width, height) {
    var _this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, WebGLRenderTarget);

    _this = _super.call(this);
    _this.width = width;
    _this.height = height;
    _this.depth = 1;
    _this.scissor = new Vector4(0, 0, width, height);
    _this.scissorTest = false;
    _this.viewport = new Vector4(0, 0, width, height);
    _this.texture = new Texture(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
    _this.texture.isRenderTargetTexture = true;
    _this.texture.image = {
      width: width,
      height: height,
      depth: 1
    };
    _this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
    _this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
    _this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;
    _this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
    _this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
    _this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
    return _this;
  }

  _createClass(WebGLRenderTarget, [{
    key: "setTexture",
    value: function setTexture(texture) {
      texture.image = {
        width: this.width,
        height: this.height,
        depth: this.depth
      };
      this.texture = texture;
    }
  }, {
    key: "setSize",
    value: function setSize(width, height) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (this.width !== width || this.height !== height || this.depth !== depth) {
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.texture.image.width = width;
        this.texture.image.height = height;
        this.texture.image.depth = depth;
        this.dispose();
      }

      this.viewport.set(0, 0, width, height);
      this.scissor.set(0, 0, width, height);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.width = source.width;
      this.height = source.height;
      this.depth = source.depth;
      this.viewport.copy(source.viewport);
      this.texture = source.texture.clone(); // ensure image object is not shared, see #20328

      this.texture.image = Object.assign({}, source.texture.image);
      this.depthBuffer = source.depthBuffer;
      this.stencilBuffer = source.stencilBuffer;
      this.depthTexture = source.depthTexture;
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: 'dispose'
      });
    }
  }]);

  return WebGLRenderTarget;
}(EventDispatcher);

WebGLRenderTarget.prototype.isWebGLRenderTarget = true;
export { WebGLRenderTarget };